export class UndefinedOrNullLangValueError extends Error {
  constructor(message: string) {
    super(message)
  }
}

export class UndefinedOrNullUUIDValueError extends Error {
  constructor(message: string) {
    super(message)
  }
}
